import { render, staticRenderFns } from "./EnergyWorkspace.vue?vue&type=template&id=6b1a76ad"
import script from "./EnergyWorkspace.vue?vue&type=script&lang=js"
export * from "./EnergyWorkspace.vue?vue&type=script&lang=js"
import style0 from "./EnergyWorkspace.vue?vue&type=style&index=0&id=6b1a76ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports